module.exports = __webpack_public_path__ + "assets/img/per-8da76735.png";